import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  FiGrid,
  FiUsers,
  FiBook,
  FiLayers,
  FiPackage,
  FiVideo,
  FiUserCheck,
  FiDollarSign,
  FiMessageSquare,
  FiHelpCircle,
  FiSettings,
  FiUser,
  FiShield,
  FiBriefcase,
} from "react-icons/fi";
import "./Sidebar.css";

const primaryNav = [
  { path: "/", icon: FiGrid, label: "Dashboard" },
  { path: "/users", icon: FiUsers, label: "Users" },
  { path: "/courses", icon: FiBook, label: "Courses" },
  { path: "/batches", icon: FiLayers, label: "Batches" },
  { path: "/modules", icon: FiPackage, label: "Modules" },
  { path: "/lectures", icon: FiVideo, label: "Lectures" },
  { path: "/enrollments", icon: FiUserCheck, label: "Enrollments" },
  { path: "/payments", icon: FiDollarSign, label: "Payments" },
  { path: "/enquiries", icon: FiMessageSquare, label: "Enquiries" },
  { path: "/hiring-requests", icon: FiBriefcase, label: "Hiring Requests" },
  { path: "/student-profiles", icon: FiUsers, label: "Student Profiles" },
  { path: "/recruiter-jobs", icon: FiBriefcase, label: "Recruiter JDs" },
  { path: "/queries", icon: FiHelpCircle, label: "Queries" },
  { path: "/settings", icon: FiSettings, label: "Settings" },
];

const Sidebar = ({
  isCollapsed,
  isMobileOpen,
  onToggleCollapse,
  onCloseMobile,
}) => {
  const { user } = useSelector((state) => state.auth);

  return (
    <>
      <div
        className={`sidebar-backdrop ${isMobileOpen ? "visible" : ""}`}
        onClick={onCloseMobile}
      />
      <aside
        className={`sidebar ${isCollapsed ? "collapsed" : ""} ${
          isMobileOpen ? "mobile-open" : ""
        }`}
      >
        <div className="sidebar-scroll">
          <div className="sidebar-header">
            <div className="brand">
              <div className="brand-mark">
                <span>PA</span>
              </div>
              {!isCollapsed && (
                <div>
                  <p className="brand-kicker">Prokopi</p>
                  <h1 className="brand-title">Admin Console</h1>
                </div>
              )}
            </div>
            <button
              type="button"
              className="collapse-btn"
              aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
              onClick={onToggleCollapse}
            >
              {isCollapsed ? "⟩" : "⟨"}
            </button>
          </div>

          <div className="sidebar-user">
            <div className="avatar-ring">
              <span>
                {user?.firstName?.[0] || "A"}
                {user?.lastName?.[0] || "D"}
              </span>
            </div>
            {!isCollapsed && (
              <div className="sidebar-user__details">
                <h2>
                  {user?.firstName} {user?.lastName}
                </h2>
                <p>{user?.role === "superadmin" ? "Super Admin" : "Admin"}</p>
              </div>
            )}
          </div>

          <nav className="sidebar-nav">
            <p className="sidebar-section-label">Navigate</p>
            <ul>
              {primaryNav.map((item) => {
                const Icon = item.icon;
                return (
                  <li key={item.path}>
                    <NavLink
                      to={item.path}
                      className={({ isActive }) =>
                        `nav-link ${isActive ? "active" : ""}`
                      }
                      onClick={isMobileOpen ? onCloseMobile : undefined}
                    >
                      <span className="nav-icon">
                        <Icon size={20} />
                      </span>
                      {!isCollapsed && (
                        <span className="nav-label">{item.label}</span>
                      )}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </nav>

          {!isCollapsed && user?.role === "superadmin" && (
            <nav className="sidebar-nav">
              <p className="sidebar-section-label">Super Admin</p>
              <ul>
                <li>
                  <NavLink
                    to="/settings/invites"
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active" : ""}`
                    }
                    onClick={isMobileOpen ? onCloseMobile : undefined}
                  >
                    <span className="nav-icon">
                      <FiShield size={20} />
                    </span>
                    <span className="nav-label">Invite Staff</span>
                  </NavLink>
                </li>
              </ul>
            </nav>
          )}

          {!isCollapsed && (
            <div className="sidebar-footer">
              <h3>Need support?</h3>
              <p>Contact the system administrator for assistance.</p>
            </div>
          )}
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
